<template>
	<vxe-modal v-model="modalShow" destroy-on-close :width="800" :height="800" show-footer @show="show" @hide="hide"
		transfer :lock-scroll="false">
		<template #title>
			<div>选择人员</div>
		</template>
		<template #default>
			<el-tabs v-model="activeName" @tab-click="handleClick" type="card">
				<el-tab-pane label="人员" name="modalStaff">
					<modalStaff :staffid="staffid" :multiple="false" ref="modalStaff" />
				</el-tab-pane>
			</el-tabs>
			<transition name="el-fade-in-linear">
				<div class="full flex form_loading" v-if="loading"
					style="background-color: rgba(255, 255, 255, .5);z-index: 999;color: #409EFF;">
					<i class="vxe-icon-refresh roll"></i>
					<span>正在加载</span>
				</div>
			</transition>
		</template>
		<template #footer>
			<vxe-button status="" content="取消" @click="modalShow=false"></vxe-button>
			<vxe-button status="primary" content="确定" @click="submit"></vxe-button>
		</template>
	</vxe-modal>
</template>
<style scoped>

</style>
<script>
	import modalStaff from '@_system/components/auth/staff.vue'
	export default {
		props: {
			customerinfo: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				staffid: [],
				loading:false,
				modalShow:false,
				activeName: 'modalStaff',

			}
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			show() {

			},
			hide() {
				this.loading = false
				this.back()
			},
			handleClick(){
				
			},
			submit(){
				let data = this.$refs.modalStaff.submitData()
				this.$emit('submit',data)
				this.back()
			},
			back() {
				this.modalShow = false
			}
		},
		components: {
			modalStaff
		}
	}
</script>